// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@awc/App/Store/Reducers";
import { color } from "@awc/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import React, { useRef } from "react";
import { Transition } from "react-transition-group";
import { TransitionStatus } from "react-transition-group/Transition";
import styled, { ThemeProps } from "styled-components";

export const StyledOverlayComponent = styled.div<{ transitionState: TransitionStatus } & ThemeProps<BaseTheme>>`
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: ${color("common.ui7", 0.4)};
    z-index: ${({ theme }: any) => {
        return theme.zIndex.styledOverlay;
    }};
    transition: opacity ease-in-out 150ms;
    ${({ transitionState }) => {
        switch (transitionState) {
            case "entering":
                return "opacity: 0;";
            case "entered":
                return "opacity: 1;";
            case "exiting":
            case "exited":
                return "opacity: 0;";
            default:
                return "";
        }
    }}
`;

const StyledOverlay = () => {
    const { registerMenu } = useAppSelector(state => ({
        registerMenu: (state as CustomAppState).xHeader.registerMenu,
    }));
    const overlayRef = useRef<HTMLDivElement | null>(null);

    return (
        <Transition
            mountOnEnter
            unmountOnExit
            in={registerMenu && registerMenu.length > 0}
            timeout={{ enter: 75, exit: 250 }}
            nodeRef={overlayRef}
        >
            {state => <StyledOverlayComponent transitionState={state} ref={overlayRef} />}
        </Transition>
    );
};

export default StyledOverlay;
